
//Import asset file(s) used by this module.
import '../../assets/skins/MainAssets.js';
import '../../assets/skins/SplashAssets.js';
import '../../assets/skins/DialogScenes.js';

/////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////

import AppInstaller from '../../../shared/src/ranj/app/core/AppInstaller.js';
import GameClock from '../../../shared/lib/html5-software-library/src/ranj/eng/story/framework/clock/GameClock.js';
import AbstractInstaller from '../../../shared/src/ranj/app/core/AbstractInstaller.js';
import AppModel from '../../../shared/src/ranj/app/core/AppModel.js';
import ContextEvent from "../../../shared/src/ranj/app/core/ContextEvent";
import ExitGameCommand from '../../../shared/src/ranj/app/core/ExitGameCommand.js';
import GameEvent from '../../../shared/src/ranj/app/core/GameEvent.js';
import SkinKeys from '../../../shared/src/ranj/app/ui/SkinKeys.js';
import InitPlatformAPIServiceTask from '../../../shared/src/ranj/equalture/platform/InitPlatformAPIServiceTask.js';
import StartGameCommand from './collaboration/controller/StartGameCommand.js';
import InitCollaborationGameTask from './collaboration/core/InitCollaborationGameTask.js';
import GameConfig from './collaboration/model/GameConfig.js';
import GameModel from './collaboration/model/GameModel.js';
import NGTAssetLocator from './collaboration/ngt/base/NGTAssetLocator.js';
import NGTVariableManager from './collaboration/ngt/base/NGTVariableManager.js';
import PlayDialogCommand from './collaboration/ngt/dialog/controller/PlayDialogCommand.js';
import DialogFactory from './collaboration/ngt/dialog/DialogFactory.js';
import CollaborationDialogPlayer from './collaboration/ngt/dialog/CollaborationDialogPlayer.js';
import DialogScreenMediator from './collaboration/ngt/dialog/view/DialogScreenMediator.js';
import DialogPlayerOptionsFixedButtonsMediator from './collaboration/ngt/dialog/view/DialogPlayerOptionsFixedButtonsMediator.js';
import InitPlaySessionTask from './collaboration/ngt/playsession/InitPlaySessionTask.js';
import PlaySessionModel from './collaboration/ngt/playsession/PlaySessionModel.js';
import AddNPCCommand from './collaboration/ngt/scenario/controller/AddNPCCommand.js';
import InitializeScenariosCommand from './collaboration/ngt/scenario/controller/InitializeScenariosCommand.js';
import PlayScenarioCommand from './collaboration/ngt/scenario/controller/PlayScenarioCommand.js';
import ScenarioCommandEvent from './collaboration/ngt/scenario/controller/ScenarioCommandEvent.js';
import NGTScenarioPlayer from './collaboration/ngt/scenario/NGTScenarioPlayer.js';
import NGTStoryFactory from './collaboration/ngt/scenario/NGTStoryFactory.js';
import NPCModel from './collaboration/ngt/scenario/NPCModel.js';
import ScenarioLibrary from './collaboration/ngt/scenario/ScenarioLibrary.js';
import ScenarioPlayerEvent from './collaboration/ngt/scenario/ScenarioPlayerEvent.js';
import EndScreenMediator from './collaboration/view/EndScreenMediator.js';
import SplashLoadScreenMediator from './collaboration/view/SplashLoadScreenMediator.js';
import TransitionScreenMediator from './collaboration/view/TransitionScreenMediator.js';
import ShowSplashScreenTask from '../../../shared/src/ranj/equalture/startup/ShowSplashScreenTask.js';
import LoadStartupAssetsTask from '../../../shared/src/ranj/app/startup/LoadStartupAssetsTask.js';
import InitLanguageTask from '../../../shared/src/ranj/equalture/startup/InitLanguageTask.js';
import SaveModel from './collaboration/model/SaveModel.js';
import SaveEvent from '../../../shared/src/ranj/equalture/savegame/SaveEvent.js';
import SaveCommand from '../../../shared/src/ranj/equalture/savegame/SaveCommand.js';
import GameCompletedCommand from './collaboration/controller/GameCompletedCommand.js';
import TrackingController from './collaboration/model/TrackingController.js';
import GameFlowEvent from './collaboration/controller/GameFlowEvent.js';
import StartScenarioCommand from './collaboration/controller/StartScenarioCommand.js';
import IntroScreenMediator from './collaboration/view/IntroScreenMediator.js';
import TransitionToDialogCommand from './collaboration/controller/TransitionToDialogCommand.js';


export default class MinigameInstaller extends AbstractInstaller {

    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        this._addAssetGroupsToList(AppInstaller.PRELOAD_ASSET_GROUPS, "SplashAssets");
        this._addAssetGroupsToList(AppInstaller.STARTUP_ASSET_GROUPS, "sounds", "common", "MainAssets", "DialogScenes");


        commands.add(ContextEvent.START_GAME, StartGameCommand);
        commands.add(GameEvent.EXIT, ExitGameCommand);
        commands.add(GameEvent.COMPLETED, GameCompletedCommand);

        injector.mapClass("appModel", AppModel, true);
        injector.mapClass("gameModel", GameModel, true);
        injector.mapClass("gameConfig", GameConfig, true);
        injector.mapValue("gameAssets", lib.MainAssets);
        injector.mapValue("dialogSceneAssets", lib.DialogScenes);
        injector.mapClass("trackingController", TrackingController, true);

        injector.mapClass("saveModel", SaveModel, true);
        commands.add(SaveEvent.SAVE, SaveCommand);
        commands.add(SaveEvent.CLEAR, SaveCommand);
        commands.add(GameFlowEvent.INTRO_COMPLETED, StartScenarioCommand);
        commands.add(GameFlowEvent.TRANSITION_TO_DIALOG, TransitionToDialogCommand);

        this._addAssetGroupsToList(AppInstaller.PRELOAD_ASSET_GROUPS, "preload");
        this._addStartupTask(InitCollaborationGameTask, "initGameTask", 0);

        this._addStartupTask(InitPlatformAPIServiceTask, "InitPlatformAPIServiceTask", 0);
        this._addStartupTask(InitLanguageTask, "InitLanguageTask", 0, ["InitPlatformAPIServiceTask"]);
        this._addStartupTask(ShowSplashScreenTask, "ShowSplashScreenTask", 0);
        this._addStartupTask(LoadStartupAssetsTask, "LoadStartupAssetsTask", 30, ["InitLanguageTask"]);
        

        SkinKeys.SPLASH_LOAD_SCREEN_SKIN = this._mapMediator(SplashLoadScreenMediator, lib.SplashAssets.SplashLoadScreenSkin);
        SkinKeys.INTRO_SCREEN = this._mapMediator(IntroScreenMediator, lib.MainAssets.IntroScreenSkin);
        SkinKeys.END_SCREEN = this._mapMediator(EndScreenMediator, lib.MainAssets.EndScreenSkin);
        SkinKeys.TRANSITION_SCREEN = this._mapMediator(TransitionScreenMediator, lib.MainAssets.TransitionScreenSkin);

        // From NGT :
        // NGT basics
        injector.mapClass("assetLocator", NGTAssetLocator, true);

        // Scenario playing
        injector.mapClass("gameClock", GameClock, true);
        injector.mapClass("variableManager", NGTVariableManager, true);

        injector.mapClass("scenarioPlayer", NGTScenarioPlayer, true);
        injector.mapClass("scenarioLibrary", ScenarioLibrary, true);
        injector.mapClass("storyFactory", NGTStoryFactory, true);
        commands.add(ScenarioCommandEvent.PLAY_SCENARIO, PlayScenarioCommand);
        commands.add(ScenarioCommandEvent.INITIALIZE_SCENARIOS, InitializeScenariosCommand);
        injector.mapClass("playSessionModel", PlaySessionModel, true);

        this._addStartupTask(InitPlaySessionTask, "initPlaySession");

        // Dialog playing
        injector.mapClass("dialogFactory", DialogFactory, true);
        injector.mapClass("dialogPlayer", CollaborationDialogPlayer, false);//NB: not a singleton!
        commands.add(ScenarioPlayerEvent.PUSH_DIALOG_AVAILABLE, PlayDialogCommand);
        SkinKeys.DIALOG_SCREEN_SKIN = this._mapMediator(DialogScreenMediator, lib.MainAssets.DialogScreenSkin);
       //SkinKeys.DIALOG_OPTIONS_SKIN = this._mapMediator(DialogPlayerOptionsAndTopicsFixedButtonsMediator);
        SkinKeys.DIALOG_OPTIONS_SKIN = this._mapMediator(DialogPlayerOptionsFixedButtonsMediator);

/////////////////////
///////////////////////
/////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////
//////////////////
    }

}
